export function initAvailability(root, modal) {
    root.querySelectorAll('[data-chalet-arrival]').forEach(button => {
        button.addEventListener('click', () => modal.open(button, button.dataset.chaletArrival));
    });
}
